module.exports = __webpack_public_path__ + "static/media/padi-light.f3f56b79.png";